/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateLocationDto } from '../models/work-create-location-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkLocation } from '../models/work-location';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkSearchChResultDto } from '../models/work-search-ch-result-dto';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateLocationDto } from '../models/work-update-location-dto';

@Injectable({ providedIn: 'root' })
export class WorkLocationsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `locationsV2ControllerGetAllDropdownOptions()` */
  static readonly LocationsV2ControllerGetAllDropdownOptionsPath = '/v2/locations/dropdown-options';

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `locationsV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  locationsV2ControllerGetAllDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkLocationsV2Service.LocationsV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `locationsV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  locationsV2ControllerGetAllDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.locationsV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `locationsV2ControllerGetAllDropdownOptionsCantons()` */
  static readonly LocationsV2ControllerGetAllDropdownOptionsCantonsPath = '/v2/locations/dropdown-options/cantons';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `locationsV2ControllerGetAllDropdownOptionsCantons()` instead.
   *
   * This method doesn't expect any request body.
   */
  locationsV2ControllerGetAllDropdownOptionsCantons$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkLocationsV2Service.LocationsV2ControllerGetAllDropdownOptionsCantonsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `locationsV2ControllerGetAllDropdownOptionsCantons$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  locationsV2ControllerGetAllDropdownOptionsCantons(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.locationsV2ControllerGetAllDropdownOptionsCantons$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `locationsV2ControllerGetAllDropdownOptionsCantonsFromSwitzerland()` */
  static readonly LocationsV2ControllerGetAllDropdownOptionsCantonsFromSwitzerlandPath = '/v2/locations/dropdown-options/all-cantons-from-ch';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `locationsV2ControllerGetAllDropdownOptionsCantonsFromSwitzerland()` instead.
   *
   * This method doesn't expect any request body.
   */
  locationsV2ControllerGetAllDropdownOptionsCantonsFromSwitzerland$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkLocationsV2Service.LocationsV2ControllerGetAllDropdownOptionsCantonsFromSwitzerlandPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `locationsV2ControllerGetAllDropdownOptionsCantonsFromSwitzerland$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  locationsV2ControllerGetAllDropdownOptionsCantonsFromSwitzerland(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.locationsV2ControllerGetAllDropdownOptionsCantonsFromSwitzerland$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `locationsV2ControllerSearchOnSearchCh()` */
  static readonly LocationsV2ControllerSearchOnSearchChPath = '/v2/locations/searchOnSearchCh';

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `locationsV2ControllerSearchOnSearchCh()` instead.
   *
   * This method doesn't expect any request body.
   */
  locationsV2ControllerSearchOnSearchCh$Response(
    params: {
      searchterm: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkSearchChResultDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkLocationsV2Service.LocationsV2ControllerSearchOnSearchChPath, 'get');
    if (params) {
      rb.query('searchterm', params.searchterm, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkSearchChResultDto>>;
      })
    );
  }

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `locationsV2ControllerSearchOnSearchCh$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  locationsV2ControllerSearchOnSearchCh(
    params: {
      searchterm: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkSearchChResultDto>> {
    return this.locationsV2ControllerSearchOnSearchCh$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkSearchChResultDto>>): Array<WorkSearchChResultDto> => r.body)
    );
  }

  /** Path part for operation `locationsV2ControllerFindAllPaginated()` */
  static readonly LocationsV2ControllerFindAllPaginatedPath = '/v2/locations/paginated';

  /**
   * Required permissions: locations:read, locations:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `locationsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  locationsV2ControllerFindAllPaginated$Response(
    params?: {
      withBusinessunit?: boolean;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by zipcode query param.
     *           <p>
     *              <b>Format: </b> filter.zipcode={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.zipcode=$not:$like:John Doe&filter.zipcode=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.zipcode'?: Array<string>;

    /**
     * Filter by name query param.
     *           <p>
     *              <b>Format: </b> filter.name={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.name=$not:$like:John Doe&filter.name=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.name'?: Array<string>;

    /**
     * Filter by canton query param.
     *           <p>
     *              <b>Format: </b> filter.canton={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.canton=$not:$like:John Doe&filter.canton=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.canton'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>name</li>
     * <li>zipcode</li>
     * <li>canton</li>
     * <li>businessunitId</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'name:ASC' | 'name:DESC' | 'zipcode:ASC' | 'zipcode:DESC' | 'canton:ASC' | 'canton:DESC' | 'businessunitId:ASC' | 'businessunitId:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,zipcode,canton
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>zipcode</li>
     * <li>canton</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkLocation>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'zipcode'?: (string | Array<string>);
'name'?: (string | Array<string>);
'canton'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkLocationsV2Service.LocationsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('withBusinessunit', params.withBusinessunit, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.zipcode', params['filter.zipcode'], {});
      rb.query('filter.name', params['filter.name'], {});
      rb.query('filter.canton', params['filter.canton'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkLocation>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'zipcode'?: (string | Array<string>);
        'name'?: (string | Array<string>);
        'canton'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: locations:read, locations:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `locationsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  locationsV2ControllerFindAllPaginated(
    params?: {
      withBusinessunit?: boolean;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by zipcode query param.
     *           <p>
     *              <b>Format: </b> filter.zipcode={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.zipcode=$not:$like:John Doe&filter.zipcode=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.zipcode'?: Array<string>;

    /**
     * Filter by name query param.
     *           <p>
     *              <b>Format: </b> filter.name={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.name=$not:$like:John Doe&filter.name=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.name'?: Array<string>;

    /**
     * Filter by canton query param.
     *           <p>
     *              <b>Format: </b> filter.canton={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.canton=$not:$like:John Doe&filter.canton=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.canton'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>name</li>
     * <li>zipcode</li>
     * <li>canton</li>
     * <li>businessunitId</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'name:ASC' | 'name:DESC' | 'zipcode:ASC' | 'zipcode:DESC' | 'canton:ASC' | 'canton:DESC' | 'businessunitId:ASC' | 'businessunitId:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,zipcode,canton
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>zipcode</li>
     * <li>canton</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkLocation>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'zipcode'?: (string | Array<string>);
'name'?: (string | Array<string>);
'canton'?: (string | Array<string>);
};
};
}> {
    return this.locationsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkLocation>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'zipcode'?: (string | Array<string>);
'name'?: (string | Array<string>);
'canton'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkLocation>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'zipcode'?: (string | Array<string>);
'name'?: (string | Array<string>);
'canton'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `locationsV2ControllerFindOneById()` */
  static readonly LocationsV2ControllerFindOneByIdPath = '/v2/locations/{id}';

  /**
   * Required permissions: locations:read, locations:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `locationsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  locationsV2ControllerFindOneById$Response(
    params: {
      id: number;
      withPowermemberships?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkLocation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkLocationsV2Service.LocationsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('withPowermemberships', params.withPowermemberships, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkLocation>;
      })
    );
  }

  /**
   * Required permissions: locations:read, locations:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `locationsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  locationsV2ControllerFindOneById(
    params: {
      id: number;
      withPowermemberships?: boolean;
    },
    context?: HttpContext
  ): Observable<WorkLocation> {
    return this.locationsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkLocation>): WorkLocation => r.body)
    );
  }

  /** Path part for operation `locationsV2ControllerDelete()` */
  static readonly LocationsV2ControllerDeletePath = '/v2/locations/{id}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `locationsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  locationsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkLocationsV2Service.LocationsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `locationsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  locationsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.locationsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `locationsV2ControllerUpdate()` */
  static readonly LocationsV2ControllerUpdatePath = '/v2/locations/{id}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `locationsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  locationsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateLocationDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkLocationsV2Service.LocationsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `locationsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  locationsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateLocationDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.locationsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `locationsV2ControllerCreate()` */
  static readonly LocationsV2ControllerCreatePath = '/v2/locations';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `locationsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  locationsV2ControllerCreate$Response(
    params: {
      body: WorkCreateLocationDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkLocation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkLocationsV2Service.LocationsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkLocation>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `locationsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  locationsV2ControllerCreate(
    params: {
      body: WorkCreateLocationDto
    },
    context?: HttpContext
  ): Observable<WorkLocation> {
    return this.locationsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkLocation>): WorkLocation => r.body)
    );
  }

}
